import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string; stack?: string };

export class AppErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: unknown): State {
    const e = error as Error;
    return { hasError: true, message: e?.message, stack: e?.stack };
  }
  componentDidCatch(error: unknown, info: unknown) {
    console.error('[AppErrorBoundary]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: 24}}>
          <h2>Something went wrong.</h2>
          <pre style={{whiteSpace: 'pre-wrap'}}>{this.state.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
